module.exports = __webpack_public_path__ + "img/Mage-draenei-f-70.c615be33.gif";